export const displayBool = (value) => {
    return value && value !== "No" ? "Yes" : "No";
};
